/* global SERVER_URL */
import React, { createContext, useEffect, useState } from 'react';
import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON, slugify } from '../utils';

export const SnapshotGalleryContext = createContext(null);

export const QueryUrls = {
  ALL: `${SERVER_URL}/snapshots/all`,
  CHANNEL: `${SERVER_URL}/snapshots/channel`,
  LIVECAM: `${SERVER_URL}/snapshots/livecam`,
  GALLERY: `${SERVER_URL}/snapshots/gallery`,
  CONTEST: `${SERVER_URL}/snapshots/contest`,
  CAMOPS: `${SERVER_URL}/snapshots/camops`,
  FAN_FAVORITES: `${SERVER_URL}/snapshots/fanfavs`,
  USER: `${SERVER_URL}/snapshots/user`,
  USER_FAVORITES: `${SERVER_URL}/snapshots/userfavs`,
};

const SnapshotGalleryProvider = ({ children = [] }) => {
  const [queryType, setQueryType] = useState(null);
  const [queryId, setQueryId] = useState(null);
  const resetGalleryMetadata = () => {};

  const contextValue = {
    resetGalleryMetadata,
    queryType,
    setQueryType,
    queryId,
    setQueryId,
  };

  return (
    <SnapshotGalleryContext.Provider value={contextValue}>
      {children}
    </SnapshotGalleryContext.Provider>
  );
};

export default SnapshotGalleryProvider;
